import { post, get, put, upload } from '@api/request';

export const searchElectronicRequests = async (
  { appraisalService },
  authenticationToken,
  { pageSize, page, payload },
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequest/search?page=${page}&pageSize=${pageSize}`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const searchElectronicRequestsAgent = async (
  { appraisalService },
  authenticationToken,
  { pageSize, page, payload },
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequestagent/search?page=${page}&pageSize=${pageSize}`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchElectronicRequestStatusCodes = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequests/status/codes`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchElectronicRequestStatusConfigs = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequests/statusconfigs`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchElectronicRequestOwners = async (
  { appraisalService },
  authenticationToken,
  { requestID }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequest/${requestID}/propertyowners`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const updateElectronicRequestOwner = async (
  { appraisalService },
  authenticationToken,
  { requestID, payload }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequest/${requestID}/propertyowner`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchElectronicRequestMethods = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequest/methods`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchElectronicRequestDetail = async (
  { appraisalService },
  authenticationToken,
  { requestID }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequest/${requestID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchElectronicRequestDetailAgent = async (
  { appraisalService },
  authenticationToken,
  { requestID }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequestagent/${requestID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const insertElectronicRequest = async (
  { appraisalService },
  authenticationToken,
  { payload }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequests`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const insertElectronicRequestAgent = async (
  { appraisalService },
  authenticationToken,
  { payload }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequestagents`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateElectronicRequest = async (
  { appraisalService },
  authenticationToken,
  { requestID, payload }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequest/${requestID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const updateElectronicRequestAgent = async (
  { appraisalService },
  authenticationToken,
  { requestID, payload }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequestagent/${requestID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const finalizeElectronicRequest = async (
  { appraisalService },
  authenticationToken,
  { requestID, payload }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequest/${requestID}/finalize`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const reopenElectronicRequest = async (
  { appraisalService },
  authenticationToken,
  { requestID, payload }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequest/${requestID}/reopen`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const insertElectronicRequestFiles = async (
  { appraisalService },
  authenticationToken,
  { requestID, payload }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequest/${requestID}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const insertElectronicRequestFilesAgent = async (
  { appraisalService },
  authenticationToken,
  { requestID, payload }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequestagent/${requestID}/files`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
};

export const updateElectronicRequestFiles = async (
  { appraisalService },
  authenticationToken,
  { requestID, payload }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequest/${requestID}/files`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const updateElectronicRequestFilesAgent = async (
  { appraisalService },
  authenticationToken,
  { requestID, payload }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequestagent/${requestID}/files`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const getElectronicRequestFile = async (
  { appraisalService },
  authenticationToken,
  { requestID, s3ID }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequest/${requestID}/file/${s3ID}`;

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);

  return await fetch(url, { headers })
    .then(response => response.blob())
    .then(blobby => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.download = requestID;
      anchor.click();

      window.URL.revokeObjectURL(objectUrl);
    });
};

export const deleteElectronicRequestFile = async (
  { appraisalService },
  authenticationToken,
  { requestID, s3ID }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequest/${requestID}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const deleteElectronicRequestFileAgent = async (
  { appraisalService },
  authenticationToken,
  { requestID, s3ID }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequestagent/${requestID}/file/${s3ID}`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const fetchElectronicRequestNotifications = async (
  { appraisalService },
  authenticationToken,
  { requestID }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequest/${requestID}/notifications`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchElectronicRequestNotificationsAgent = async (
  { appraisalService },
  authenticationToken,
  { requestID }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequestagent/${requestID}/portalnotifications`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchElectronicRequestNotificationsAgentAppeals = async (
  { appraisalService },
  authenticationToken,
  { requestID, page, pageSize, pID, portalUser }
) => {
  let url = `${appraisalService}/appraisal/electronicdeliveryrequestagent/${requestID}/appealactivity?page=${page}&pageSize=${pageSize}`;
  if (portalUser) {
    url += `&portalUser=${portalUser}`;
  }
  if (pID) {
    url += `&pID=${pID}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchElectronicRequestNotificationDetailsAgent = async (
  { appraisalService },
  authenticationToken,
  { notificationID, page, pageSize, pID }
) => {
  let url = `${appraisalService}/appraisal/electronicdeliveryrequestagent/${notificationID}/portalnotificationdetails?page=${page}&pageSize=${pageSize}`;
  if(pID) {
    url = `${url}&pID=${pID}`;
  }
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchElectronicRequestRevisionHistory = async (
  { appraisalService },
  authenticationToken,
  { requestID }
) => {
  const url = `${appraisalService}/appraisal/revisionhistory/electronicdeliveryrequest/${requestID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const rescindElectronicRequestAgent = async (
  { appraisalService },
  authenticationToken,
  { requestID }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequestagent/${requestID}/rescind`;
  const { body } = await put(authenticationToken, url);
  return body;
};

export const fetchElectronicRequestRevisionHistoryAgent = async (
  { appraisalService },
  authenticationToken,
  { requestID }
) => {
  const url = `${appraisalService}/appraisal/revisionhistory/electronicdeliveryrequestagents/${requestID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const massFinalizeElectronicRequests = async (
  { appraisalService },
  authenticationToken,
  { payload }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequests/massfinalize`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const massRescindElectronicRequests = async (
  { appraisalService },
  authenticationToken,
  { payload }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequests/massrescind`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const fetchElectronicDeliveryNotifications = async (
  { appraisalService },
  authenticationToken,
  { requestID }
) => {
  const url = `${appraisalService}/appraisal/electronicdeliveryrequest/${requestID}/portalnotifications`;
  const { body } = await get(authenticationToken, url);
  return body;
};